export interface Skill {
  id: string;
  name: string;
}

export const skills: Skill[] = [
  { id: "php", name: "PHP" },
  { id: "laravel", name: "Laravel" },
  { id: "symfony", name: "Symfony" },
  { id: "mysql", name: "MySQL" },
  { id: "postgresql", name: "PostgreSQL" },
  { id: "html", name: "HTML" },
  { id: "css", name: "CSS" },
  { id: "tailwind", name: "Tailwind" },
  { id: "js", name: "JS" },
  { id: "jquery", name: "jQuery" },
  { id: "sass", name: "SASS" },
  { id: "vue", name: "Vue.js" },
  { id: "alpine", name: "Alpine.js" },
  { id: "typescript", name: "TypeScript" },
  { id: "gitlab", name: "GitLab" },
  { id: "docker", name: "Docker" },
  { id: "macos", name: "macOS" },
  { id: "elasticsearch", name: "ElasticSearch" },
  { id: "rest", name: "REST API" },
  { id: "solid", name: "SOLID" },
  { id: "ddd", name: "Domain Driven Design" },
];
